import React, { useRef, useEffect, useState } from 'react';
import Popup from 'components/common/popUp/PopUp';
import styles from './challengeWindow.css';
import Share from 'assets/svg/share-button.svg';
import { useDispatch, useSelector } from 'react-redux';
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    EmailShareButton,
} from 'react-share';

import Linkedin from 'assets/svg/linkedinSocial.svg';
import Facebook from 'assets/svg/facebookSocial.svg';
import Twitter from 'assets/svg/twitterSocial.svg';
import Mail from 'assets/svg/email2.svg';
import ReactWOW from '../../components/react-wow/src';
import get from 'lodash.get';
import { shareChallengeCalendar } from '../../data/player/calendar/action';
import { getShareURL, getFontFamily, getSwitchClassNameOrColourWithBackground } from '../../utils/func';

/**
 *
 * @type {React.NamedExoticComponent<{readonly quizType?: *, readonly allowChallenges?: *, readonly id?: *, readonly settings?: {reward_amount: *, challenge_enable?: *, appearance?: *}, readonly titleQuiz?: *, readonly closeChallengePopup?: *, readonly typeId?: *, readonly font_family?: *, readonly type?: *}>}
 */
const ChallengeWindow = React.memo( ( {
                                          closeChallengePopup, titleQuiz, settings: { reward_amount, challenge_enable, appearance },
                                          allowChallenges, font_family, quizType, typeId, id: calendarOrQuizID, type: sharableType
                                      } ) => {

    const { localization: { content }, shareChallenge } = useSelector( ( state ) => state );
    let copyMessageRef = useRef();
    const dispatch = new useDispatch();

    const [ urlShare, setUrlShare ] = useState( '' );
    useEffect( () => {
        const urlShare = getShareURL( get( shareChallenge, 'key' ), quizType, typeId ).toString();
        setUrlShare( urlShare );
    }, [ shareChallenge ] );

    useEffect( () => {
        createChallenge();
    }, [] );

    const copyToClipboard = ( str ) => {
        const tmpArea = document.createElement( 'textarea' );
        tmpArea.value = str;
        tmpArea.setAttribute( 'readonly', '' );
        tmpArea.style.position = 'absolute';
        tmpArea.style.left = '-9999px';
        document.body.appendChild( tmpArea );
        tmpArea.select();
        document.execCommand( 'copy' );
        document.body.removeChild( tmpArea );
        copyMessageRef.current.className = styles.copyLink__messageVisible;
        setTimeout( () => copyMessageRef.current.className = styles.copyLink__messageHidden, 2000 );
        createChallenge();
    };

    const handleClose = e => {
        e.target.style.animation = `${ styles.closePopup } 0.05s`;
        setTimeout( closeChallengePopup, 100 );
    };

    const createChallenge = () => {
        if ( allowChallenges ) {
            dispatch( shareChallengeCalendar( calendarOrQuizID, calendarOrQuizID, sharableType ) ); // works for calendar and quiz
        }
    };

    const textAutoColorClass = getSwitchClassNameOrColourWithBackground( appearance.background_color, 'lightBgPlaceholder', 'darkBgPlaceholder' );
    const backgroundAutoClass = getSwitchClassNameOrColourWithBackground( appearance.background_color, 'darkBg', 'lightBg' );
    const svgAutoFillColor = getSwitchClassNameOrColourWithBackground( appearance.background_color, 'lightBgSvg', 'darkBgSvg' );
    const fontFamily = getFontFamily( font_family ).fontFamilyH2;
    const fontFamilDefault = getFontFamily( font_family ).defaultFont;

    const windowStyle = {
        minHeight: '57rem',
        maxHeight: document.documentElement.clientHeight > 375 ? '80%' : '90%',
        width: document.documentElement.clientWidth > 420 ? '75%' : '85%',
        maxWidth: '100rem',
        borderRadius: '2rem',
    };

    const closeBtnStyle = {
        width: '90%',
        marginTop: '4rem',
        marginBottom: '2rem',
        fontWeight: 'bold',
        maxWidth: '40rem',
        fontFamily: fontFamilDefault
    };

    const isNotAcademy = ( quizType !== 'academy' );


    return (
        <Popup handleClose={ closeChallengePopup } windowStyle={ windowStyle }>
            <ReactWOW animation='fadeInUp' duration='0.5s'>
                <div
                    className={ `${ styles.wrapper } ${ styles[ backgroundAutoClass ] } ${ styles[ textAutoColorClass ] }` }
                    style={ { boxShadow: '0 12px 54px 0 rgba(0, 0, 0, 0.5)' } }
                >
                    <div className={ styles[ svgAutoFillColor ] }>
                        <Share className={ `${ styles.shareSvg }` }/>
                    </div>
                    <h2 style={ { fontFamily: fontFamily } }
                        className={ styles.title }>{ content.quiz.editor.share_with_your_friends }</h2>

                    { !!allowChallenges && !!challenge_enable && isNotAcademy &&
                    <React.Fragment>
                        <p style={ { fontFamily: fontFamilDefault } }
                           className={ styles.subTitle }>
                            { content.get_bonus_points }
                        </p>
                        <p style={ { fontFamily: fontFamilDefault } }
                           className={ `${ styles.text } ${ styles[ textAutoColorClass ] }` }>
                            { content.challenge_text_quiz } <b
                            className={ styles[ textAutoColorClass ] }>{ reward_amount } { content.bonus }</b> { content.points_score }
                        </p>
                    </React.Fragment>
                    }

                    <div className={ `${ styles.containerSocialLink }  ${ styles[ svgAutoFillColor ] }` }>
                        <LinkedinShareButton
                            url={ urlShare }
                            title={ titleQuiz ? titleQuiz : '' }>
                            <Linkedin onClick={ createChallenge } className={ `${ styles[ svgAutoFillColor ] }` }/>
                        </LinkedinShareButton>

                        <FacebookShareButton url={ urlShare }>
                            <Facebook onClick={ createChallenge }/>
                        </FacebookShareButton>

                        <TwitterShareButton url={ urlShare }>
                            <Twitter onClick={ createChallenge }/>
                        </TwitterShareButton>
                        <EmailShareButton
                            subject='email'
                            body='body'
                            url={ urlShare }
                        >
                            <Mail onClick={ createChallenge }/>
                        </EmailShareButton>
                    </div>

                    <input
                        className={ `${ styles.share_link } ${ styles[ textAutoColorClass ] }` }
                        type='text'
                        onCopy={ createChallenge }
                        defaultValue={ urlShare }
                    />

                    <div className={ styles.copyLink }>
                            <span className={ styles.copyLink__messageHidden }
                                  style={ { color: get( appearance, 'button_style.backgroundColor' ) } }
                                  ref={ copyMessageRef }>
                                { content.quiz.players.link_copied_to_clipboard }
                            </span>
                        <button
                            className={ styles.share_btn }
                            onClick={ copyToClipboard.bind( null, urlShare ) }
                            style={ {
                                fontFamily: fontFamilDefault,
                                ...appearance.button_style
                            } }
                            aria-label={ content.quiz.link.copy_link_aria_label }
                        >
                            <span style={ { textOverflow: 'ellipsis', visibility: 'none' } }>
                                { content.quiz.link.copy_link }
                            </span>
                        </button>
                    </div>
                    <button className={ styles.share_btn }
                        aria-label={ content.close_aria_label }
                            style={ { ...closeBtnStyle, ...appearance.button_secondary_style } }
                            onClick={ handleClose }>
                        { content.close }
                    </button>
                </div>
            </ReactWOW>
        </Popup>
    );
} );

export default ChallengeWindow;